<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-marginless is-main-content is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeMarche.filtre.code')">
            <b-input v-model="critereRecherche.code"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeMarche.filtre.libelle')">
            <b-input v-model="critereRecherche.libelle"></b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeMarche.filtre.fournisseur')">
            <b-autocomplete
              :value="libelleFournisseur"
              :data="fournisseurs"
              :loading="isFetchingFournisseur"
              :open-on-focus="false"
              @input="getFournisseur"
              @select="setFournisseur"
              field="nomCommercial"
              icon="magnify">
              <template slot="empty">
                <div v-if="!isFetchingFournisseur">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { getAll as getAllTiers, get as getTiers } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
  TIERS_TYPE_FOURNISSEUR,
} from '@/configuration/tiers/tiersConf';
import { RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche from '@/services/achat/marche/genererCritereRecherche';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/achat/marche-mutation-type';

const Marche = createNamespacedHelpers('marche');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
  },
  data() {
    return {
      critereRecherche: null,
      libelleFournisseur: null,
      fournisseurs: [],
      isFetchingFournisseur: false,
    };
  },
  computed: {
    ...Marche.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Marche.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    getFournisseur: debounce(async function fournisseurData(text) {
      if (text === this.libelleFournisseur) return;
      try {
        this.libelleFournisseur = text;
        this.critereRecherche.fournisseurId = null;
        this.isFetchingFournisseur = true;
        this.fournisseurs = (await getAllTiers({
          query: {
            nomCommercial: text,
            type: TIERS_TYPE_FOURNISSEUR,
            sousType: [TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT],
            societeId: this.societeActiveId,
            archive: false,
          },
          limit: RESULTS_PER_PAGE,
        })).data.result.items;
        this.isFetchingFournisseur = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingFournisseur = false;
        throw e;
      }
    }),
    setFournisseur(newFournisseur) {
      if (!newFournisseur) return;
      this.libelleFournisseur = newFournisseur.nomCommercial;
      this.critereRecherche.fournisseurId = newFournisseur.id;
    },
    viderCritere() {
      const critereRecherche = genererCritereRecherche();
      this.critereRecherche = critereRecherche;
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      try {
        if (this.critereRecherche.fournisseurId) {
          const fournisseur = (await getTiers(this.critereRecherche.fournisseurId)).data.result;
          this.setFournisseur(fournisseur);
        }
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
